// AuthListenerWrapper.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "../../Supabase/SupabaseClient";

// Función para sincronizar el usuario en la tabla "usuarios"
const syncUserWithSupabase = async (user) => {
  if (!user) return;
  const { id, email, user_metadata } = user;
  const displayName = user_metadata?.nombre || email;
// quite data,error
  const {  error } = await supabase
    .from("usuarios")
    .upsert([
      {
        id,
        email,
        nombre: displayName || "Usuario sin nombre",
      },
    ]);

  if (error) {
    console.error("Error al sincronizar usuario:", error.message);
  } 
  // saque el else de data
};

const AuthListenerWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (session?.user) {
          // Sincronizamos al usuario en la tabla "usuarios"
          syncUserWithSupabase(session.user);

          // Si el usuario está en la página de login, redirigimos según su rol
          if (location.pathname === "/login") {
            // Consultamos el rol del usuario en la tabla "usuarios"
            supabase
              .from("usuarios")
              .select("rol")
              .eq("id", session.user.id)
              .maybeSingle()
              .then(({ data, error }) => {
                if (error) {
                  console.error("Error al obtener el rol del usuario:", error.message);
                  return;
                }
                if (data) {
                  if (data.rol === "Admin") {
                    navigate("/admin");
                  } else {
                    navigate("/"); // Redirige a Home o a otra ruta para usuarios normales
                  }
                }
              });
          }
        }
      }
    );

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [navigate, location]);

  return null; // Este componente no renderiza nada
};

export default AuthListenerWrapper;
